export default {
  testimonials: state => state.testimonials,
  testimonial: state => state.testimonial
}
